import { render, staticRenderFns } from "./mediationCommitteeList.vue?vue&type=template&id=659b2728&scoped=true"
import script from "./mediationCommitteeList.vue?vue&type=script&lang=js"
export * from "./mediationCommitteeList.vue?vue&type=script&lang=js"
import style0 from "./mediationCommitteeList.vue?vue&type=style&index=0&id=659b2728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659b2728",
  null
  
)

export default component.exports